<script lang="ts">
  import { run, preventDefault } from "svelte/legacy";

  import Button from "../../components/atoms/Button.svelte";
  import EstimationSlider from "../../components/molecules/EstimationSlider.svelte";
  import Estimation from "../../components/molecules/Estimation.svelte";
  import ZipCode from "../../components/molecules/ZipCode.svelte";
  import usePurchaseModule from "../../providers/usePurchaseModule";

  const { state: store, send } = usePurchaseModule();

  let facilityInformation = $store.context.facilityInformation;
  let residenceType = $state(facilityInformation.residenceType);
  let zipcode = $state(
    facilityInformation && $store.context.facilityInformation.zipcode?.length > 0
      ? $store.context.facilityInformation.zipcode
      : undefined
  );

  let zipCodeValid = $state(false);
  let estimation = $state($store.context.estimation > 0 ? $store.context.estimation : 20000);
  let showContinue = $state((zipCodeValid || $store.context.moving) && estimation > 0);

  $effect(() => {
    if (zipcode != undefined && estimation != undefined) {
      showContinue = (zipCodeValid || $store.context.moving) && estimation > 0;
    } else {
      showContinue = false;
    }
  });

  const onClickNext = () => {
    if (showContinue) {
      send("SET_ESTIMATION", { data: { estimation: estimation } });
      send("SET_RESIDENCE_TYPE", { data: { residenceType } });
      send("SET_ZIP_CODE", { data: { zipcode: zipcode.toString() } });
      send("NEXT");
    }
  };
</script>

<form onsubmit={preventDefault(onClickNext)} class=" ">
  {#if $store.context.forceShowEstimation}
    <EstimationSlider {residenceType} bind:inputEstimationValue={estimation}>
      {#snippet heading()}
        <span>1. Hur stor är din elförbrukning?</span>
      {/snippet}
      {#snippet text()}
        <span
          >Uppskatta din årliga elförbrukning. Du kan antingen ange storleken på ditt boende genom
          att föra knappen längs linjen eller fylla i förbrukningen i rutan själv om du vet ungefär
          hur den brukar se ut.</span
        >
      {/snippet}
    </EstimationSlider>
  {:else}
    <Estimation bind:inputEstimationValue={estimation} bind:residenceType>
      {#snippet heading()}
        <span>1. Hur stor är din elförbrukning?</span>
      {/snippet}
      {#snippet text()}
        <span
          >Uppskatta din årliga elförbrukning. Du kan antingen ange storleken på ditt boende genom
          att föra knappen längs linjen eller fylla i förbrukningen i rutan själv om du vet ungefär
          hur den brukar se ut.</span
        >
      {/snippet}
    </Estimation>
  {/if}
  {#if !$store.context.moving}
    <ZipCode bind:valid={zipCodeValid} bind:zipcode>
      2. Fyll i ditt postnummer och klicka på ”beräkna pris” för att se din beräknade månadskostnad.
    </ZipCode>
  {/if}
  {#if showContinue}
    <Button type={"submit"} disabled={!showContinue} class="w-full mt-5">Beräkna pris</Button>
  {/if}
</form>
